{
  "en": {
    "marketplace_partner": {
      "contact_me": {
        "success": "We will get in touch with you shortly.",
        "failure": "An unexpected error occurred.",
        "button": "Contact me!"
      }
    }
  }
}
